import { getFileFromUrl } from './file-utilities';

export const getMuxThumbnail = (playbackId: string) => `https://image.mux.com/${playbackId}/thumbnail.png`;

export const getMuxHlsPlayback = (playbackId: string) => {
  //`https://stream.mux.com/${playbackId}.m3u8`;
  return `${playbackId}`;
};

export const HLS_MIMETYPE = 'application/x-mpegurl';

/**
 * [hackish]
 * Generate a File object from mux playbackId
 * The File object won't actually play,
 * we just need the filename to supply to `ReactPlayer` url
 *
 * @param playbackId mux playback id
 * @returns File
 */
export const generateFileFromPlaybackId = async (playbackId: string) => {
  const hlsLink = getMuxHlsPlayback(playbackId);
  const file = await getFileFromUrl(hlsLink, HLS_MIMETYPE);
  return file;
};
